/* Industrialsafety-UK product page: help rows under the buy buttons + quote dialog (2-10-2026) */
(function () {
  'use strict';
  var help = document.querySelector('[data-isu-help]');
  var dlg = document.getElementById('isu-quote');
  var qty = document.querySelector('[data-isu-qty]');
  var linear = (document.querySelector('[data-isu-pdp]') || {}).getAttribute ? document.querySelector('[data-isu-pdp]').getAttribute('data-linear') === 'true' : false;

  function amount() {
    var n = qty ? parseInt(qty.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function variantTitle() {
    var sel = document.querySelector('.isu-pf select[name="id"], .isu-pf [data-isu-id]');
    if (sel && sel.tagName === 'SELECT' && sel.selectedOptions[0]) return sel.selectedOptions[0].textContent.trim();
    return '';
  }

  /* email link: product, size, grade, amount and link in the body */
  if (help) {
    var mail = help.querySelector('[data-isu-mail]');
    if (mail) {
      mail.addEventListener('click', function () {
        var d = help.dataset, lines = ['Product: ' + d.title];
        if (d.size) lines.push('Size: ' + d.size);
        if (d.grade) lines.push('Grade: ' + d.grade);
        var vt = variantTitle();
        if (vt) lines.push('Option: ' + vt);
        lines.push((linear ? 'Length: ' + amount() + ' m' : 'Quantity: ' + amount()));
        lines.push('Link: ' + d.url, '', '');
        mail.href = 'mailto:' + d.email + '?subject=' + encodeURIComponent('Enquiry: ' + d.title) + '&body=' + encodeURIComponent(lines.join('\n'));
      });
    }
  }

  if (!dlg || typeof dlg.showModal !== 'function') {
    document.querySelectorAll('[data-isu-qopen]').forEach(function (b) { b.addEventListener('click', function (e) { if (dlg) { e.preventDefault(); dlg.setAttribute('open', ''); } }); });
    return;
  }
  var opener = null;
  function open(e) {
    if (e) e.preventDefault();
    opener = document.activeElement;
    var q = dlg.querySelector('[data-isu-qqty]');
    if (q) q.value = amount();
    var vf = dlg.querySelector('[data-isu-qvariant]'), vt = variantTitle();
    if (vf && vt) vf.value = vt;
    dlg.showModal();
    document.documentElement.classList.add('isu-qd-open');
    var first = dlg.querySelector('[data-isu-qstatus]') || dlg.querySelector('input:not([type="hidden"])');
    if (first) first.focus();
  }
  function close() { dlg.close(); }
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('isu-qd-open');
    if (opener && opener.focus) opener.focus();
  });
  document.querySelectorAll('[data-isu-qopen]').forEach(function (b) { b.addEventListener('click', open); });
  dlg.querySelectorAll('[data-isu-qclose]').forEach(function (b) { b.addEventListener('click', close); });
  dlg.addEventListener('click', function (e) {
    var r = dlg.getBoundingClientRect();
    if (e.target === dlg && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) close();
  });
  /* after sending, the page reloads with the result: show it */
  if (dlg.querySelector('[data-isu-qstatus]')) open();
  if (window.location.hash === '#isu-quote') open();
})();
